export const Constants = {
  TAG_NAME: 'pop-maturity-and-duration-table-component',
  MATURITY_COLUMN_HEADER: 'Maturity',
  DURATION_COLUMN_HEADER: 'Duration',
  PERCENT_OF_PORTFOLIO_COLUMN_HEADER: '% of portfolio',
  BENCHMARK_COLUMN_HEADER: '% of benchmark',
  EMPTY_CELL_VALUE: 'N/A',
} as const;
